export default __webpack_public_path__ + "static/media/rocket_anim_29.1e21e47e.png";